module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_22.dot-bc96f257b5790a991946c52409ffb641.svg";